module.exports = __webpack_public_path__ + "img/starfighter-twin-ion-engine-advanced.1f35c373.svg";